module.exports = __webpack_public_path__ + "static/evan-spiegel-232a903029616e6efc0a666eda5d259e.jpg";